export default {
  // Navigation
  'nav.home': 'Home',
  'nav.portfolio': 'Ons Werk',
  'nav.materials': 'Kleuren & Afwerkingen',
  'nav.contact': 'Contact',
  
  // Hero Section
  'hero.title': 'Specialist in Trappen en Vloeren',
  'hero.subtitle': 'Expert in traprenovatie, houten vloeren, PVC vloeren en laminaat vloer. Professioneel trap bekleden en vloeren leggen voor uw woning.',
  'hero.cta': 'Bekijk Ons Werk',
  'hero.whatsapp': 'WhatsApp Contact',
  
  // Notice
  'notice.title': 'Belangrijk',
  'notice.text': 'Plaats uw bestelling via WhatsApp of vul het contactformulier in. Wij nemen snel contact met u op.',
  
  // Home - Features
  'features.title': 'Waarom Kiezen Voor Onze Trappen en Vloeren Service',
  'features.custom.title': 'Traprenovatie Op Maat',
  'features.custom.desc': 'Professionele traprenovatie en trap bekleden volgens uw wensen. Van klassiek tot modern.',
  'features.quality.title': 'Vloeren Specialist',
  'features.quality.desc': 'Expert in houten vloeren, PVC vloeren en laminaat vloer. Vakkundig vloeren leggen met jarenlange ervaring.',
  'features.variety.title': 'Diverse Materialen',
  'features.variety.desc': 'Ruime keuze in trapbekleding en vloeren: hout, PVC, laminaat en meer. Voor elke stijl en budget.',
  'features.expert.title': 'Vakkundig Advies',
  'features.expert.desc': 'Persoonlijk advies over traprenovatie en vloeren leggen. Van ontwerp tot installatie.',
  
  // Home - Process
  'process.title': 'Ons Werkproces',
  'process.step1.title': 'Contact via WhatsApp',
  'process.step1.desc': 'Neem contact met ons op via WhatsApp met uw ideeën en vereisten.',
  'process.step2.title': 'Ontwerp & Offerte',
  'process.step2.desc': 'We maken een aangepast ontwerp en geven u een gedetailleerde offerte.',
  'process.step3.title': 'Productie',
  'process.step3.desc': 'Uw trap wordt met precisie en zorg vervaardigd.',
  'process.step4.title': 'Installatie',
  'process.step4.desc': 'Professionele installatie zorgt voor een perfect eindresultaat.',
  
  // Portfolio
  'portfolio.title': 'Ons Werk: Trappen en Vloeren Projecten',
  'portfolio.subtitle': 'Bekijk onze gerealiseerde projecten in traprenovatie, trap bekleden en vloeren leggen. Van houten vloeren tot PVC trapbekleding.',
  'portfolio.filter.all': 'Alle',
  'portfolio.filter.modern': 'Modern',
  'portfolio.filter.wood': 'Hout',
  'portfolio.filter.steel': 'Staal',
  'portfolio.filter.concrete': 'Beton',
  'portfolio.filter.glass': 'Glas',
  
  // Portfolio Items
  'portfolio.item1': 'Moderne Zwevende Trap',
  'portfolio.item2': 'Klassieke Houten Trap',
  'portfolio.item3': 'Industriële Stalen Trap',
  'portfolio.item4': 'Minimalistische Betonnen Trap',
  'portfolio.item5': 'Glazen Balustrade Trap',
  'portfolio.item6': 'Spiraalvormige Stalen Trap',
  'portfolio.item7': 'Rustieke Eiken Trap',
  'portfolio.item8': 'Hedendaagse Zwarte Stalen Trap',
  'portfolio.item9': 'Luxe Walnoten Trap',
  'portfolio.item10': 'Moderne Glas & Staal Trap',
  'portfolio.item11': 'Architectonische Betonnen Trap',
  'portfolio.item12': 'Elegante Witte Trap',
  
  // Materials
  'materials.title': 'Materialen voor Trappen en Vloeren',
  'materials.subtitle': 'Kies uit ons uitgebreide assortiment voor traprenovatie en vloeren: PVC vloeren, houten vloeren, laminaat vloer en trapbekleding. Maatwerk kleuren mogelijk.',
  'materials.wood.title': 'Hout Afwerkingen',
  'materials.wood.oak': 'Eiken',
  'materials.wood.walnut': 'Walnoot',
  'materials.wood.ash': 'Es',
  'materials.wood.teak': 'Teak',
  'materials.wood.maple': 'Esdoorn',
  'materials.wood.cherry': 'Kers',
  'materials.metal.title': 'Metaal Opties',
  'materials.metal.steel': 'Geborsteld Staal',
  'materials.metal.black': 'Zwart Staal',
  'materials.metal.bronze': 'Brons',
  'materials.metal.brass': 'Messing',
  'materials.metal.copper': 'Koper',
  'materials.metal.chrome': 'Chroom',
  'materials.painted.title': 'Gelakte Afwerkingen',
  'materials.painted.white': 'Zuiver Wit',
  'materials.painted.black': 'Mat Zwart',
  'materials.painted.grey': 'Antraciet Grijs',
  'materials.painted.navy': 'Marineblauw',
  'materials.painted.green': 'Bosgroen',
  'materials.painted.custom': 'Maatwerk RAL Kleur',
  'materials.custom.title': 'Maatwerk Kleuren Beschikbaar',
  'materials.custom.text': 'Heeft u een specifieke kleur of afwerking in gedachten? We kunnen elke RAL kleur of aangepaste afwerking realiseren. Neem contact met ons op via WhatsApp om uw opties te bespreken.',
  
  // Contact
  'contact.title': 'Contact voor Traprenovatie en Vloeren',
  'contact.subtitle': 'Klaar voor professionele traprenovatie of vloeren leggen? Neem contact op via WhatsApp voor een persoonlijke offerte.',
  'contact.whatsapp.title': 'WhatsApp Contact',
  'contact.whatsapp.text': 'De snelste manier om contact met ons op te nemen is via WhatsApp. Klik op de knop hieronder om een gesprek te starten.',
  'contact.whatsapp.button': 'Open WhatsApp',
  'contact.whatsapp.message': 'Hallo, ik ben geïnteresseerd in traprenovatie en vloeren. Kunnen jullie mij meer informatie geven?',
  'contact.hours.title': 'Openingstijden',
  'contact.hours.weekdays': 'Maandag - Vrijdag: 8:00 - 18:00',
  'contact.hours.saturday': 'Zaterdag: 9:00 - 15:00',
  'contact.hours.sunday': 'Zondag: Gesloten',
  'contact.notice.title': 'Belangrijke Mededeling',
  'contact.notice.text': 'Bestellingen kunnen niet via deze website worden geplaatst. Alle aanvragen, offertes en bestellingen verlopen uitsluitend via WhatsApp contact. Dit zorgt ervoor dat we uw specifieke wensen volledig begrijpen en u de beste service kunnen bieden.',
  'contact.info.title': 'Waarom WhatsApp?',
  'contact.info.point1': 'Direct contact met ons team',
  'contact.info.point2': 'Deel foto\'s en ideeën gemakkelijk',
  'contact.info.point3': 'Snelle reactietijden',
  'contact.info.point4': 'Persoonlijk advies op maat',
  
  // Footer
  'footer.tagline': 'Uw specialist in trappen en vloeren',
  'footer.description': 'Expert in traprenovatie, trap bekleden, houten vloeren, PVC vloeren en laminaat vloer. Professioneel vloeren leggen door ervaren vakmannen.',
  'footer.quick.title': 'Snelle Links',
  'footer.contact.title': 'Contact',
  'footer.whatsapp': 'WhatsApp',
  'footer.hours': 'Ma-Vr: 8:00-18:00',
  'footer.copyright': '© 2024 De Trappen en Vloeren Meesters. Alle rechten voorbehouden.',
  'footer.powered': 'Website Builder',
  
  // WhatsApp Button
  'whatsapp.tooltip': 'Chat met ons op WhatsApp',
  
  // 404 Page
  'notfound.title': 'Pagina Niet Gevonden',
  'notfound.text': 'Sorry, de pagina die u zoekt bestaat niet.',
  'notfound.button': 'Terug naar Home',
  contact: {
    title: 'Contact',
    subtitle: 'Neem contact met ons op via WhatsApp',
    whatsappButton: 'Chat op WhatsApp',
    whatsappMessage: 'Hallo, ik ben geïnteresseerd in traprenovatie en vloeren. Kunnen we de mogelijkheden bespreken?',
    businessHours: 'Openingstijden',
    monday: 'Maandag - Vrijdag',
    hours: '08:00 - 18:00',
    saturday: 'Zaterdag',
    saturdayHours: '09:00 - 14:00',
    sunday: 'Zondag',
    closed: 'Gesloten',
    notice: 'Let op: Bestellingen kunnen niet via de website worden geplaatst. Alle aanvragen verlopen via WhatsApp.',
    formTitle: 'Of vul het contactformulier in',
    formSubtitle: 'Wij nemen zo snel mogelijk contact met u op',
    formName: 'Naam',
    formNamePlaceholder: 'Uw volledige naam',
    formAddress: 'Adres',
    formAddressPlaceholder: 'Straat, huisnummer, postcode, plaats',
    formEmail: 'E-mailadres',
    formEmailPlaceholder: 'uw.email@voorbeeld.nl',
    formPhone: 'Telefoonnummer',
    formPhonePlaceholder: '+31 6 12345678',
    formMessage: 'Bericht (optioneel)',
    formMessagePlaceholder: 'Vertel ons over uw trapproject...',
    formPhoto: 'Foto van uw trap (optioneel)',
    formPhotoPlaceholder: 'Klik om een foto te uploaden',
    formSubmit: 'Verstuur aanvraag',
    formSuccess: 'Bedankt! Uw aanvraag is verzonden. We nemen spoedig contact met u op.',
    formError: 'Er is iets misgegaan. Probeer het opnieuw of neem contact op via WhatsApp.',
  },
};